export default class StorageService {
    static addItem(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    }

    static getItem(key) {
        const item = localStorage.getItem(key);
        return JSON.parse(item)
    }

    static removeItem(key) {
        localStorage.removeItem(key)
    }
}